export default __webpack_public_path__ + "static/media/script-inactive.d105a2ab.png";